import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import axios from "axios";
import * as GeneralStore from "../../store/GeneralStore";
import { State } from "../../store";
import "./dashboard.css";
import { DefaultButton } from "@fluentui/react";
import { ReportApi } from "../../api/reportApi";
import { FaBullhorn } from "react-icons/fa";
import DashboardCard from "./DashboardCard";
import OrderVisualization from "./OrderVisualization";
import OrdersList from "./OrdersList";
import NominationPage from "./NominationPage";
import AnnouncementModal
 from "./AnnouncementModal";
type Props = GeneralStore.GeneralState &
  typeof GeneralStore.actionCreators;

const DashboardPage: FC<Props> = (props: Props) => {
  const [throughputData, setThroughputData] = useState<any>();
  const [selectedNomination, setSelectedNomination] = useState<any>(null);
  const [summary, setSummary] = useState<any>({});
  const [ showAnnouncement, setShowAnnouncement ] = useState(false);
  const [cycletimeData, setCycletimeData] = useState<any>();

  const [cycletimeMulti, setCycletimeMulti] = useState<any>();
  const [cycletimeSingle, setCycletimeSingle] = useState<any>();

  const onSelectNomination = (val:any) => {
    setSelectedNomination(val);
  }
  const getSummary = async () =>{
    const response= await axios.get(`/api/Report/status/summary`);
    
    setSummary(response.data);
  }

  useEffect(() => {
    getSummary();
  }, []);

  const [nominations, setNominations] = useState<any[]>([
          {
              nominationNo: 123, name: 'Tank 1125', updatedAt: '2024-07-30T08:36:00Z',
              criticalMeasurements: {
                  "level": {
                      "displayName": "LIT-125-01",
                      "fieldName": "LIT-0125-0001",
                      "processValue": 63.797000885009766,
                      "setPoint": 50.0,
                      "hihiAlarm": {
                          "setPoint": 66.6240005493164,
                      },
                      "hiAlarm": {
                          "setPoint": 65.58499908447266
                      },
                      "loAlarm": {},
                      "loloAlarm": {},
                      "valueMin": 0.0,
                      "valueMax": 67.5
                  }
              }, brand: 'Petron', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 86.94, temp_c: 6.58, temp_h: 1.48 },
          {
              nominationNo: 456, name: 'Tank 8975', updatedAt: '2024-06-25T15:00:00Z',
              criticalMeasurements: {
                  "level": {
                      "displayName": "LIT-125-01",
                      "fieldName": "LIT-0125-0001",
                      "processValue": 65.797000885009766,
                      "setPoint": 50.0,
                      "hihiAlarm": {
                          "setPoint": 66.6240005493164,
                      },
                      "hiAlarm": {
                          "setPoint": 65.58499908447266
                      },
                      "loAlarm": {},
                      "loloAlarm": {},
                      "valueMin": 0.0,
                      "valueMax": 67.5
                  }
              }, brand: 'Shell', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 76.94, temp_c: 5.58, temp_h: 0.58 },
          {
              nominationNo: 789, name: 'Tank 1546', updatedAt: '2024-07-30T01:00:00Z',
              criticalMeasurements: {
                  "level": {
                      "displayName": "LIT-125-01",
                      "fieldName": "LIT-0125-0001",
                      "processValue": 23.797000885009766,
                      "setPoint": 50.0,
                      "hihiAlarm": {
                          "setPoint": 66.6240005493164,
                      },
                      "hiAlarm": {
                          "setPoint": 65.58499908447266
                      },
                      "loAlarm": {},
                      "loloAlarm": {},
                      "valueMin": 0.0,
                      "valueMax": 67.5
                  }
              }, brand: 'Union', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 36.94, temp_c: 7.58, temp_h: 0.18 },
          {
              nominationNo: 321, name: 'Tank 1798', updatedAt: '2023-06-25T01:00:00Z',
              criticalMeasurements: {
                  "level": {
                      "displayName": "LIT-125-01",
                      "fieldName": "LIT-0125-0001",
                      "processValue": 43.797000885009766,
                      "setPoint": 50.0,
                      "hihiAlarm": {
                          "setPoint": 66.6240005493164,
                      },
                      "hiAlarm": {
                          "setPoint": 65.58499908447266
                      },
                      "loAlarm": {},
                      "loloAlarm": {},
                      "valueMin": 0.0,
                      "valueMax": 67.5
                  }
              }, brand: 'BP Chemicals', chemical: 'Monoethylene glycol', mode: 'ACTIVE', temp_f: 56.94, temp_c: 5.38, temp_h: 2.48 },
          {
              nominationNo: 654, name: 'Tank 1234', updatedAt: '2024-07-30T01:00:00Z',
              criticalMeasurements: {
                  "level": {
                      "displayName": "LIT-125-01",
                      "fieldName": "LIT-0125-0001",
                      "processValue": 13.797000885009766,
                      "setPoint": 50.0,
                      "hihiAlarm": {
                          "setPoint": 66.6240005493164,
                      },
                      "hiAlarm": {
                          "setPoint": 65.58499908447266
                      },
                      "loAlarm": {},
                      "loloAlarm": {},
                      "valueMin": 0.0,
                      "valueMax": 67.5
                  }
              }, brand: 'Union', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 36.94, temp_c: 7.58, temp_h: 0.18 },
          {
              nominationNo: 987, name: 'Tank 5678', updatedAt: '2024-05-25T12:00:00Z',
              criticalMeasurements: {
                  "level": {
                      "displayName": "LIT-125-01",
                      "fieldName": "LIT-0125-0001",
                      "processValue": 33.797000885009766,
                      "setPoint": 50.0,
                      "hihiAlarm": {
                          "setPoint": 66.6240005493164,
                      },
                      "hiAlarm": {
                          "setPoint": 65.58499908447266
                      },
                      "loAlarm": {},
                      "loloAlarm": {},
                      "valueMin": 0.0,
                      "valueMax": 67.5
                  }
              }, brand: 'BP Chemicals', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 56.94, temp_c: 5.38, temp_h: 2.48 },
          {
              nominationNo: 154, name: 'Tank 9123', updatedAt: '2024-07-25T15:40:00Z',
              criticalMeasurements: {
                  "level": {
                      "displayName": "LIT-125-01",
                      "fieldName": "LIT-0125-0001",
                      "processValue": 1.797000885009766,
                      "setPoint": 50.0,
                      "hihiAlarm": {
                          "setPoint": 66.6240005493164,
                      },
                      "hiAlarm": {
                          "setPoint": 65.58499908447266
                      },
                      "loAlarm": {},
                      "loloAlarm": {},
                      "valueMin": 0.0,
                      "valueMax": 67.5
                  }
              }, brand: 'Shell', chemical: 'Monoethylene glycol', mode: 'ACTIVE', temp_f: 76.94, temp_c: 5.58, temp_h: 0.58 },
  
      ]);

  return (
    <>
      {selectedNomination===null ? (
      <div className="wrapper">
        <div className="flex justify-between">
          <h1 className="text-sm underline">Dashboard</h1>
          <span className="data-right">
            <span className="data-date">
              Data as of {moment().format("MM/DD/YY")}
            </span>
            <DefaultButton className="announcement" onClick={()=>setShowAnnouncement(true)}><FaBullhorn/></DefaultButton>
          </span>
        </div>
        <div className="flex justify-between" style={{gap:'10px'}}>
          <DashboardCard type="Tank" data={summary?.marine}/>
          <DashboardCard type="Truck" data={summary?.truck}/>
          <DashboardCard type="Rail" data={summary?.rail}/>
          {/* <div className="dashboard-announcement">
            <h6>Announcement</h6>
            <p>Bay 1 Tank 2 is temporarily unavailable due to maintenance. We're working to restore access ASAP. Thank you for your patience.</p>
          </div> */}
        </div>

        <div className="modality flex flex-row justify-between">
          <OrderVisualization data={throughputData}/>
        </div>
        <div className="modality flex flex-row justify-between">
          <OrdersList data={nominations} onSelect={onSelectNomination}/>
        </div>
        {/* <div className="modality flex flex-row justify-between">
          <div className="label">Cycle Time for All Modalities</div>
        </div>
        <div className="bar-chart">
          <div className="chart-heading">Average Cycle Time Breakdown per Modality (Hrs) for Current Year</div>
          {cycletimeMulti?.length > 0 &&
            <BarChart 
              years={(cycletimeData?.multiParcel || [])?.map( (m: any) => m.year)}
              series={cycletimeMulti}
            />
          }
          </div> */}
          {showAnnouncement && (
          <AnnouncementModal
            {...props}
            onClose={() => setShowAnnouncement(false)}
          />
        )}
      </div>
      ):(
        <NominationPage data={selectedNomination} onBack={onSelectNomination}/>
      )}
      {/* <div
        style={{
          position: "fixed",
          bottom: "50px",
          right: "50px"
        }}
      >
        {props.versionNumber}
      </div> */}
    </>
  );
};

export default connect(
  (state: State) => ({
    ...state.general
  }),
  {
    ...GeneralStore.actionCreators
  }
)(DashboardPage as any);